/**
 * @generated SignedSource<<2b54cf32229fc51f96b93b31a343f187>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SavePushTokenPayload",
    "kind": "LinkedField",
    "name": "savePushToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Error",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InboxQuery_savePushTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InboxQuery_savePushTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "71aa4b3f5adf8a82c226c48c8bba752b",
    "id": null,
    "metadata": {},
    "name": "InboxQuery_savePushTokenMutation",
    "operationKind": "mutation",
    "text": "mutation InboxQuery_savePushTokenMutation(\n  $input: SavePushTokenInput!\n) {\n  savePushToken(input: $input) {\n    ok\n    error {\n      message\n    }\n  }\n}\n"
  }
};
})();

node.hash = "c091b1f7558dd5d572c74c5dab37c0e9";

module.exports = node;
